/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {creativeFunctions} from './creative.resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AssetService} from './asset/asset.service';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the LibraryCreative HTTP resource (factory product). */
export class LibraryCreativeResource {
}

export function createLibraryCreativeResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile,
  Asset: any
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const LibraryCreative: any = createAdnHttpResource(send, 'librarycreatives', () => localUserProfile);
  const uri = ApiConfig.obtain().getVersionedUri('librarycreatives');

  LibraryCreative.copy = function(params: any): any {
    return {
      $promise: send({
        method: 'POST',
        url: uri + '/' + encodeURIComponent(params.id) + '/copy',
        params: _.pick(params, ['lineItemId', 'creativeId', 'name', 'userState']),
        body: params
      })
    };
  };
  creativeFunctions(LibraryCreative, Asset);
  return LibraryCreative;
}

export const libraryCreativeResourceProvider = {
  provide: LibraryCreativeResource,
  useFactory: createLibraryCreativeResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile, AssetService]
};

